
import * as util from 'util'

import * as big from '../big'
import * as int64 from '../int64'
import * as uuid from '../uuid'

import * as fbe from '../fbe'
import * as core from '../core'
import * as config from '../config'
import * as history from '../history'
import * as client from '../client'
import * as feed from '../feed'
import * as storage from '../storage'
import * as exposed from '../exposed'
import * as execution from '../execution'
import * as backup from '../backup'
import * as inner from '../inner'
import * as trade from '../trade'
import * as security from '../security'
import * as document from '../document'

const Big = big.Big // eslint-disable-line
const Int64 = int64.Int64 // eslint-disable-line
const UInt64 = int64.UInt64 // eslint-disable-line
const UUID = uuid.UUID // eslint-disable-line
import {Request} from '../core/Request';
import {FieldModelRequest} from '../core/Request';
import {AccountUpgradeToSocialTradingMasterResponse} from './AccountUpgradeToSocialTradingMasterResponse';
import {SocialTradingAllocationMethod} from '../core/SocialTradingAllocationMethod';
import {FieldModelSocialTradingAllocationMethod} from '../core/SocialTradingAllocationMethod';
import {SocialTradingAccountMode} from '../core/SocialTradingAccountMode';
import {FieldModelSocialTradingAccountMode} from '../core/SocialTradingAccountMode';

/**
 * AccountUpgradeToSocialTradingMasterRequest struct
 */
class AccountUpgradeToSocialTradingMasterRequest extends Request {
  /**
   * Initialize struct
   * @param {!Request=} parent
   * @param {!number=} login
   * @param {!SocialTradingAllocationMethod=} allocationMethod
   * @param {!SocialTradingAccountMode=} accountMode
   * @param {!number=} commissionLogin
   * @param {!number=} feePercent
   * @constructor
   */
  constructor (parent = new Request(), login = new UInt64(0, 0), allocationMethod = new SocialTradingAllocationMethod(), accountMode = new SocialTradingAccountMode(), commissionLogin = new UInt64(0, 0), feePercent = 0.0) {
    super()
    super.copy(parent)
    this.Login = login
    this.AllocationMethod = allocationMethod
    this.AccountMode = accountMode
    this.CommissionLogin = commissionLogin
    this.FeePercent = feePercent
  }

  /**
   * Copy struct (shallow copy)
   * @this {!AccountUpgradeToSocialTradingMasterRequest}
   * @param {!AccountUpgradeToSocialTradingMasterRequest} other Other struct
   * @returns {!AccountUpgradeToSocialTradingMasterRequest} This struct
   */
  copy (other) {
    super.copy(other)
    if (other.Login != null) {
      this.Login = UInt64.fromNumber(other.Login)
    } else {
      this.Login = null
    }
    if (other.AllocationMethod != null) {
      this.AllocationMethod = SocialTradingAllocationMethod.fromObject(other.AllocationMethod)
    } else {
      this.AllocationMethod = null
    }
    if (other.AccountMode != null) {
      this.AccountMode = SocialTradingAccountMode.fromObject(other.AccountMode)
    } else {
      this.AccountMode = null
    }
    if (other.CommissionLogin != null) {
      this.CommissionLogin = UInt64.fromNumber(other.CommissionLogin)
    } else {
      this.CommissionLogin = null
    }
    if (other.FeePercent != null) {
      this.FeePercent = other.FeePercent
    } else {
      this.FeePercent = null
    }
    return this
  }

  /**
   * Clone struct (deep clone)
   * @this {!AccountUpgradeToSocialTradingMasterRequest}
   * @returns {!AccountUpgradeToSocialTradingMasterRequest} Cloned struct
   */
  clone () {
    // Serialize the struct to the FBE stream
    let writer = new AccountUpgradeToSocialTradingMasterRequestModel(new fbe.WriteBuffer())
    writer.serialize(this)

    // Deserialize the struct from the FBE stream
    let reader = new AccountUpgradeToSocialTradingMasterRequestModel(new fbe.ReadBuffer())
    reader.attachBuffer(writer.buffer)
    return reader.deserialize().value
  }

  /**
   * Is this struct equal to other one?
   * @this {!AccountUpgradeToSocialTradingMasterRequest}
   * @param {!AccountUpgradeToSocialTradingMasterRequest} other Other struct
   * @returns {boolean} Equal result
   */
  eq (other) {
    if (!(other instanceof AccountUpgradeToSocialTradingMasterRequest)) {
      throw new TypeError('Instance of AccountUpgradeToSocialTradingMasterRequest is required!')
    }
    // noinspection RedundantIfStatementJS
    if (!super.eq(other)) {
      return false
    }
    return true
  }

  /**
   * Convert struct to JSON
   * @this {!AccountUpgradeToSocialTradingMasterRequest}
   * @returns {!object} Struct value for JSON
   */
  toJSON () {
    let parent = super.toJSON()
    let current = {
      Login: ((this.Login != null) ? this.Login.toNumber() : null),
      AllocationMethod: ((this.AllocationMethod != null) ? this.AllocationMethod : null),
      AccountMode: ((this.AccountMode != null) ? this.AccountMode : null),
      CommissionLogin: ((this.CommissionLogin != null) ? this.CommissionLogin.toNumber() : null),
      FeePercent: ((this.FeePercent != null) ? this.FeePercent : null)
    }
    return { ...parent, ...current }
  }

  /**
   * Convert JSON to struct
   * @param {!string} json JSON string
   * @returns {!object} Struct value for JSON
   */
  static fromJSON (json) {
    return AccountUpgradeToSocialTradingMasterRequest.fromObject(JSON.parse(json))
  }

  /**
   * Create struct from object value
   * @param {!AccountUpgradeToSocialTradingMasterRequest} other Object value
   * @returns {!AccountUpgradeToSocialTradingMasterRequest} Created struct
   */
  static fromObject (other) {
    return new AccountUpgradeToSocialTradingMasterRequest().copy(other)
  }

  /**
   * Get the FBE type
   * @this {!AccountUpgradeToSocialTradingMasterRequest}
   * @returns {!number} FBE type
   */
  get fbeType () {
    return AccountUpgradeToSocialTradingMasterRequest.fbeType
  }

  /**
   * Get the FBE type (static)
   * @this {!AccountUpgradeToSocialTradingMasterRequest}
   * @returns {!number} FBE type
   */
  static get fbeType () {
    return 6475
  }
}

export { AccountUpgradeToSocialTradingMasterRequest };

/**
 * Fast Binary Encoding AccountUpgradeToSocialTradingMasterRequest field model
 */
class FieldModelAccountUpgradeToSocialTradingMasterRequest extends fbe.FieldModel {
  /**
   * Initialize field model with the given buffer and offset
   * @param {!fbe.ReadBuffer|!fbe.WriteBuffer} buffer Buffer
   * @param {!number} offset Offset
   * @constructor
   */
  constructor (buffer, offset) {
    super(buffer, offset)
    this._parent = new FieldModelRequest(buffer, 4 + 4)
    this.Login = new fbe.FieldModelUInt64(buffer, this._parent.fbeOffset + this._parent.fbeBody - 4 - 4)
    this.AllocationMethod = new FieldModelSocialTradingAllocationMethod(buffer, this.Login.fbeOffset + this.Login.fbeSize)
    this.AccountMode = new FieldModelSocialTradingAccountMode(buffer, this.AllocationMethod.fbeOffset + this.AllocationMethod.fbeSize)
    this.CommissionLogin = new fbe.FieldModelUInt64(buffer, this.AccountMode.fbeOffset + this.AccountMode.fbeSize)
    this.FeePercent = new fbe.FieldModelDouble(buffer, this.CommissionLogin.fbeOffset + this.CommissionLogin.fbeSize)
  }

  /**
   * Get the core.Request field model
   * @this {!FieldModelAccountUpgradeToSocialTradingMasterRequest}
   * @returns {!FieldModelRequest} core.Request field model
   */
  get parent () {
    return this._parent
  }

  /**
   * Get the field size
   * @this {!FieldModelAccountUpgradeToSocialTradingMasterRequest}
   * @returns {!number} Field size
   */
  get fbeSize () {
    return 4
  }

  /**
   * Get the field body size
   * @this {!FieldModelAccountUpgradeToSocialTradingMasterRequest}
   * @returns {!number} Field body size
   */
  get fbeBody () {
    return 4 + 4 + this.parent.fbeBody - 4 - 4 + this.Login.fbeSize + this.AllocationMethod.fbeSize + this.AccountMode.fbeSize + this.CommissionLogin.fbeSize + this.FeePercent.fbeSize
  }

  /**
   * Get the field extra size
   * @this {!FieldModelAccountUpgradeToSocialTradingMasterRequest}
   * @returns {!number} Field extra size
   */
  get fbeExtra () {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4) > this._buffer.size)) {
      return 0
    }

    this._buffer.shift(fbeStructOffset)

    let fbeResult = this.fbeBody + this.parent.fbeExtra + this.Login.fbeExtra + this.AllocationMethod.fbeExtra + this.AccountMode.fbeExtra + this.CommissionLogin.fbeExtra + this.FeePercent.fbeExtra

    this._buffer.unshift(fbeStructOffset)

    return fbeResult
  }

  /**
   * Get the field type
   * @this {!FieldModelAccountUpgradeToSocialTradingMasterRequest}
   * @returns {!number} Field type
   */
  get fbeType () {
    return FieldModelAccountUpgradeToSocialTradingMasterRequest.fbeType
  }

  /**
   * Get the field type (static)
   * @this {!FieldModelAccountUpgradeToSocialTradingMasterRequest}
   * @returns {!number} Field type
   */
  static get fbeType () {
    return 6475
  }

  /**
   * Check if the struct value is valid
   * @this {!FieldModelAccountUpgradeToSocialTradingMasterRequest}
   * @param {!boolean} fbeVerifyType Verify model type flag, defaults is true
   * @returns {!boolean} Field model valid state
   */
  verify (fbeVerifyType = true) {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return true
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4 + 4) > this._buffer.size)) {
      return false
    }

    let fbeStructSize = this.readUInt32(fbeStructOffset)
    if (fbeStructSize < (4 + 4)) {
      return false
    }

    let fbeStructType = this.readUInt32(fbeStructOffset + 4)
    if (fbeVerifyType && (fbeStructType !== this.fbeType)) {
      return false
    }

    this._buffer.shift(fbeStructOffset)
    let fbeResult = this.verifyFields(fbeStructSize)
    this._buffer.unshift(fbeStructOffset)
    return fbeResult
  }

  /**
   * Check if the struct fields are valid
   * @this {!FieldModelAccountUpgradeToSocialTradingMasterRequest}
   * @param {!number} fbeStructSize FBE struct size
   * @returns {!boolean} Field model valid state
   */
  verifyFields (fbeStructSize) {
    let fbeCurrentSize = 4 + 4

    if ((fbeCurrentSize + this.parent.fbeBody - 4 - 4) > fbeStructSize) {
      return true
    }
    if (!this.parent.verifyFields(fbeStructSize)) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.parent.fbeBody - 4 - 4

    if ((fbeCurrentSize + this.Login.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.Login.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.Login.fbeSize

    if ((fbeCurrentSize + this.AllocationMethod.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.AllocationMethod.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.AllocationMethod.fbeSize

    if ((fbeCurrentSize + this.AccountMode.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.AccountMode.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.AccountMode.fbeSize

    if ((fbeCurrentSize + this.CommissionLogin.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.CommissionLogin.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.CommissionLogin.fbeSize

    if ((fbeCurrentSize + this.FeePercent.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.FeePercent.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.FeePercent.fbeSize

    return true
  }

  /**
   * Get the struct value (begin phase)
   * @this {!FieldModelAccountUpgradeToSocialTradingMasterRequest}
   * @returns {!number} Field model begin offset
   */
  getBegin () {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    console.assert((fbeStructOffset > 0) && ((this._buffer.offset + fbeStructOffset + 4 + 4) <= this._buffer.size), 'Model is broken!')
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4 + 4) > this._buffer.size)) {
      return 0
    }

    let fbeStructSize = this.readUInt32(fbeStructOffset)
    console.assert((fbeStructSize >= (4 + 4)), 'Model is broken!')
    if (fbeStructSize < (4 + 4)) {
      return 0
    }

    this._buffer.shift(fbeStructOffset)
    return fbeStructOffset
  }

  /**
   * Get the struct value (end phase)
   * @this {!FieldModelAccountUpgradeToSocialTradingMasterRequest}
   * @param {!number} fbeBegin Field model begin offset
   */
  getEnd (fbeBegin) {
    this._buffer.unshift(fbeBegin)
  }

  /**
   * Get the struct value
   * @this {!FieldModelAccountUpgradeToSocialTradingMasterRequest}
   * @param {!AccountUpgradeToSocialTradingMasterRequest} fbeValue Default value, defaults is new AccountUpgradeToSocialTradingMasterRequest()
   * @returns {!AccountUpgradeToSocialTradingMasterRequest} AccountUpgradeToSocialTradingMasterRequest value
   */
  get (fbeValue = new AccountUpgradeToSocialTradingMasterRequest()) {
    let fbeBegin = this.getBegin()
    if (fbeBegin === 0) {
      return fbeValue
    }

    let fbeStructSize = this.readUInt32(0)
    this.getFields(fbeValue, fbeStructSize)
    this.getEnd(fbeBegin)
    return fbeValue
  }

  /**
   * Get the struct fields values
   * @this {!FieldModelAccountUpgradeToSocialTradingMasterRequest}
   * @param {!AccountUpgradeToSocialTradingMasterRequest} fbeValue AccountUpgradeToSocialTradingMasterRequest value
   * @param {!number} fbeStructSize Struct size
   */
  getFields (fbeValue, fbeStructSize) {
    let fbeCurrentSize = 4 + 4

    if ((fbeCurrentSize + this.parent.fbeBody - 4 - 4) <= fbeStructSize) {
      this.parent.getFields(fbeValue, fbeStructSize)
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.parent.fbeBody - 4 - 4

    if ((fbeCurrentSize + this.Login.fbeSize) <= fbeStructSize) {
      fbeValue.Login = this.Login.get()
    } else {
      fbeValue.Login = new UInt64(0, 0)
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.Login.fbeSize

    if ((fbeCurrentSize + this.AllocationMethod.fbeSize) <= fbeStructSize) {
      fbeValue.AllocationMethod = this.AllocationMethod.get()
    } else {
      fbeValue.AllocationMethod = new SocialTradingAllocationMethod()
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.AllocationMethod.fbeSize

    if ((fbeCurrentSize + this.AccountMode.fbeSize) <= fbeStructSize) {
      fbeValue.AccountMode = this.AccountMode.get()
    } else {
      fbeValue.AccountMode = new SocialTradingAccountMode()
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.AccountMode.fbeSize

    if ((fbeCurrentSize + this.CommissionLogin.fbeSize) <= fbeStructSize) {
      fbeValue.CommissionLogin = this.CommissionLogin.get()
    } else {
      fbeValue.CommissionLogin = new UInt64(0, 0)
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.CommissionLogin.fbeSize

    if ((fbeCurrentSize + this.FeePercent.fbeSize) <= fbeStructSize) {
      fbeValue.FeePercent = this.FeePercent.get()
    } else {
      fbeValue.FeePercent = 0.0
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.FeePercent.fbeSize
  }

  /**
   * Set the struct value (begin phase)
   * @this {!FieldModelAccountUpgradeToSocialTradingMasterRequest}
   * @returns {!number} Field model begin offset
   */
  setBegin () {
    console.assert(((this._buffer.offset + this.fbeOffset + this.fbeSize) <= this._buffer.size), 'Model is broken!')
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructSize = this.fbeBody
    let fbeStructOffset = this._buffer.allocate(fbeStructSize) - this._buffer.offset
    console.assert((fbeStructOffset > 0) && ((this._buffer.offset + fbeStructOffset + fbeStructSize) <= this._buffer.size), 'Model is broken!')
    if ((fbeStructOffset <= 0) || ((this._buffer.offset + fbeStructOffset + fbeStructSize) > this._buffer.size)) {
      return 0
    }

    this.writeUInt32(this.fbeOffset, fbeStructOffset)
    this.writeUInt32(fbeStructOffset, fbeStructSize)
    this.writeUInt32(fbeStructOffset + 4, this.fbeType)

    this._buffer.shift(fbeStructOffset)
    return fbeStructOffset
  }

  /**
   * Set the struct value (end phase)
   * @this {!FieldModelAccountUpgradeToSocialTradingMasterRequest}
   * @param {!number} fbeBegin Field model begin offset
   */
  setEnd (fbeBegin) {
    this._buffer.unshift(fbeBegin)
  }

  /**
   * Set the struct value
   * @this {!FieldModelAccountUpgradeToSocialTradingMasterRequest}
   * @param {!AccountUpgradeToSocialTradingMasterRequest} fbeValue AccountUpgradeToSocialTradingMasterRequest value
   */
  set (fbeValue) {
    let fbeBegin = this.setBegin()
    if (fbeBegin === 0) {
      return
    }

    this.setFields(fbeValue)
    this.setEnd(fbeBegin)
  }

  /**
   * Set the struct fields values
   * @this {!FieldModelAccountUpgradeToSocialTradingMasterRequest}
   * @param {AccountUpgradeToSocialTradingMasterRequest} fbeValue AccountUpgradeToSocialTradingMasterRequest value
   */
  setFields (fbeValue) {
    this.parent.setFields(fbeValue)
    this.Login.set(fbeValue.Login)
    this.AllocationMethod.set(fbeValue.AllocationMethod)
    this.AccountMode.set(fbeValue.AccountMode)
    this.CommissionLogin.set(fbeValue.CommissionLogin)
    this.FeePercent.set(fbeValue.FeePercent)
  }
}

export { FieldModelAccountUpgradeToSocialTradingMasterRequest };

/**
 * Fast Binary Encoding AccountUpgradeToSocialTradingMasterRequest model
 */
class AccountUpgradeToSocialTradingMasterRequestModel extends fbe.Model {
  /**
   * Initialize model with the given buffer
   * @param {!fbe.ReadBuffer|!fbe.WriteBuffer} buffer Read/Write buffer, defaults is new fbe.WriteBuffer()
   * @constructor
   */
  constructor (buffer = new fbe.WriteBuffer()) {
    super(buffer)
    this._model = new FieldModelAccountUpgradeToSocialTradingMasterRequest(this.buffer, 4)
  }

  /**
   * Get the AccountUpgradeToSocialTradingMasterRequest model
   * @this {!AccountUpgradeToSocialTradingMasterRequestModel}
   * @returns {!FieldModelAccountUpgradeToSocialTradingMasterRequest} model AccountUpgradeToSocialTradingMasterRequest model
   */
  get model () {
    return this._model
  }

  /**
   * Get the model size
   * @this {!AccountUpgradeToSocialTradingMasterRequestModel}
   * @returns {!number} Model size
   */
  get fbeSize () {
    return this.model.fbeSize + this.model.fbeExtra
  }

  /**
   * Get the model type
   * @this {!AccountUpgradeToSocialTradingMasterRequestModel}
   * @returns {!number} Model type
   */
  get fbeType () {
    return AccountUpgradeToSocialTradingMasterRequestModel.fbeType
  }

  /**
   * Get the model type (static)
   * @this {!AccountUpgradeToSocialTradingMasterRequestModel}
   * @returns {!number} Model type
   */
  static get fbeType () {
    return FieldModelAccountUpgradeToSocialTradingMasterRequest.fbeType
  }

  /**
   * Check if the struct value is valid
   * @this {!AccountUpgradeToSocialTradingMasterRequestModel}
   * @returns {!boolean} Model valid state
   */
  verify () {
    if ((this.buffer.offset + this.model.fbeOffset - 4) > this.buffer.size) {
      return false
    }

    let fbeFullSize = this.readUInt32(this.model.fbeOffset - 4)
    if (fbeFullSize < this.model.fbeSize) {
      return false
    }

    return this.model.verify()
  }

  /**
   * Create a new model (begin phase)
   * @this {!AccountUpgradeToSocialTradingMasterRequestModel}
   * @returns {!number} Model begin offset
   */
  createBegin () {
    return this.buffer.allocate(4 + this.model.fbeSize)
  }

  /**
   * Create a new model (end phase)
   * @this {!AccountUpgradeToSocialTradingMasterRequestModel}
   * @param {!number} fbeBegin Model begin offset
   */
  createEnd (fbeBegin) {
    let fbeEnd = this.buffer.size
    let fbeFullSize = fbeEnd - fbeBegin
    this.writeUInt32(this.model.fbeOffset - 4, fbeFullSize)
    return fbeFullSize
  }

  /**
   * Serialize the struct value
   * @this {!AccountUpgradeToSocialTradingMasterRequestModel}
   * @param {!AccountUpgradeToSocialTradingMasterRequest} value AccountUpgradeToSocialTradingMasterRequest value
   * @return {!number} Model begin offset
   */
  serialize (value) {
    let fbeBegin = this.createBegin()
    this.model.set(value)
    return this.createEnd(fbeBegin)
  }

  /**
   * Deserialize the struct value
   * @this {!AccountUpgradeToSocialTradingMasterRequestModel}
   * @param {!AccountUpgradeToSocialTradingMasterRequest} value AccountUpgradeToSocialTradingMasterRequest value, defaults is new AccountUpgradeToSocialTradingMasterRequest()
   * @return {!object} Deserialized AccountUpgradeToSocialTradingMasterRequest value and its size
   */
  deserialize (value = new AccountUpgradeToSocialTradingMasterRequest()) {
    if ((this.buffer.offset + this.model.fbeOffset - 4) > this.buffer.size) {
      return { value: new AccountUpgradeToSocialTradingMasterRequest(), size: 0 }
    }

    let fbeFullSize = this.readUInt32(this.model.fbeOffset - 4)
    console.assert((fbeFullSize >= this.model.fbeSize), 'Model is broken!')
    if (fbeFullSize < this.model.fbeSize) {
      return { value: new AccountUpgradeToSocialTradingMasterRequest(), size: 0 }
    }

    this.model.get(value)
    return { value: value, size: fbeFullSize }
  }

  /**
   * Move to the next struct value
   * @this {!AccountUpgradeToSocialTradingMasterRequestModel}
   * @param {!number} prev Previous AccountUpgradeToSocialTradingMasterRequest model size
   */
  next (prev) {
    this.model.fbeShift(prev)
  }
}

export { AccountUpgradeToSocialTradingMasterRequestModel };
AccountUpgradeToSocialTradingMasterRequest.__has_response = true;
AccountUpgradeToSocialTradingMasterRequest.__response_class = AccountUpgradeToSocialTradingMasterResponse;
